<question
  [quoteType]="quoteType"
  [asset_type]="asset_type"
  [asset_id]="asset_id"
  [assetTypeDisplayName]="assetTypeDisplayName"
  (showBackButton)="compShowBackButton($event)"
  (navigateQuestionSummary)="compNavigateQuestionSummary()"
  
  (navigateQuoteEndorsement)="compNavigateQuoteEndorsement($event)"
  (navigateHomeQuote)="compNavigateHomeQuote()"
  (navigateWalletPage)="compNavigateWalletPage()"
></question>
